import React from 'react';
import { 
  Typography, 
  List, 
  ListItem, 
  ListItemButton, 
  ListItemText,
  Box 
} from '@mui/material';
import MenuBookIcon from '@mui/icons-material/MenuBook';

const TableOfContents = ({ sections, onSectionClick }) => {
  return (
    <Box sx={{ p: 3, height: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <MenuBookIcon sx={{ mr: 1, color: 'primary.main' }} />
        <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
          Table of Contents
        </Typography>
      </Box>
      
      <List dense sx={{ '& .MuiListItem-root': { mb: 0.5 } }}>
        {sections.map((section, index) => (
          <Box key={section.id}>
            <ListItem disablePadding>
              <ListItemButton 
                onClick={() => onSectionClick(section.id)}
                sx={{ 
                  borderRadius: 2,
                  '&:hover': {
                    backgroundColor: 'primary.light',
                    color: 'white',
                    '& .MuiListItemText-primary': {
                      color: 'white'
                    }
                  },
                  transition: 'all 0.2s ease'
                }}
              >
                <ListItemText 
                  primary={`${index + 1}. ${section.title}`}
                  primaryTypographyProps={{ 
                    variant: 'body2',
                    fontWeight: 'medium',
                    sx: { 
                      fontSize: '0.875rem',
                      lineHeight: 1.4
                    }
                  }}
                />
              </ListItemButton>
            </ListItem>
            
            {section.subsections && (
              <List component="div" disablePadding sx={{ pl: 2, mb: 1 }}>
                {section.subsections.map((subsection, subIndex) => (
                  <ListItem key={subsection.id} disablePadding>
                    <ListItemButton 
                      onClick={() => onSectionClick(subsection.id)}
                      sx={{ 
                        borderRadius: 1,
                        py: 0.5,
                        '&:hover': {
                          backgroundColor: 'secondary.light',
                          '& .MuiListItemText-primary': {
                            color: 'secondary.dark'
                          }
                        },
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <ListItemText 
                        primary={`${index + 1}.${subIndex + 1} ${subsection.title}`}
                        primaryTypographyProps={{ 
                          variant: 'caption',
                          sx: { 
                            color: 'text.secondary',
                            fontSize: '0.75rem',
                            lineHeight: 1.3
                          }
                        }}
                      />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            )}
          </Box>
        ))}
      </List>
    </Box>
  );
};

export default TableOfContents;